import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// image
import logo from '@images/logo-full.png';
import loginbg from '@images/pic1.png';
import { AuthActions } from '@adapters/redux/reducer/auth';

function Login(props) {
  const [username, setUsername] = useState('');
  let errorsObj = { username: '', password: '' };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (username === '') {
      errorObj.username = 'Username is Required';
      error = true;
    }
    if (password === '') {
      errorObj.password = 'Password is Required';
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    props.signIn({ username, password }, navigate);
  }

  return (
    <div className="authincation d-flex flex-column flex-lg-row flex-column-fluid">
      <div className="login-aside text-center  d-flex flex-column flex-row-auto">
        <div className="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <div className="text-center mb-4 pt-5">
            <img src={logo} alt="" />
          </div>
          <h3 className="mb-2">Welcome back!</h3>
        </div>
        <div
          className="aside-image"
          style={{ backgroundImage: 'url(' + loginbg + ')' }}
        ></div>
      </div>
      <div className="container flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
        <div className="d-flex justify-content-center h-100 align-items-center">
          <div className="authincation-content style-2">
            <div className="row no-gutters">
              <div className="col-xl-12 tab-content">
                <div id="sign-in" className="auth-form form-validation">
                  <form onSubmit={onLogin} className="form-validate">
                    <h3 className="text-center mb-4 text-black">
                      Sign in your account
                    </h3>
                    {props.error && (
                      <div className="text-center red-text p-1 my-2">
                        {props.error}
                      </div>
                    )}
                    {props.successMessage && (
                      <div className="text-center green-text p-1 my-2">
                        {props.successMessage}
                      </div>
                    )}
                    <div className="form-group mb-3">
                      <label className="mb-1" htmlFor="val-username">
                        <strong>Username</strong>
                      </label>
                      <div>
                        <input
                          type="username"
                          className="form-control"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Type Your Username"
                        />
                      </div>
                      {errors.username && (
                        <div className="text-danger fs-12">
                          {errors.username}
                        </div>
                      )}
                    </div>
                    <div className="form-group mb-3">
                      <label className="mb-1">
                        <strong>Password</strong>
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        value={password}
                        placeholder="Type Your Password"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {errors.password && (
                        <div className="text-danger fs-12">
                          {errors.password}
                        </div>
                      )}
                    </div>
                    <div className="text-center form-group mb-3">
                      <button
                        type="submit"
                        disabled={props.loading}
                        className="btn btn-primary btn-block"
                      >
                        Sign In
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  error: state.auth.error,
  loading: state.auth.isProcessing,
});

const mapDispatchToProps = (dispatch) => ({
  signIn: (params, navigate) => dispatch(AuthActions.login(params, navigate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
